import { Container, Typography, Paper, Box } from "@mui/material";
import SeoHead from "../components/SeoHead";

const sections = [
  {
    title: "I. Information Collection",
    body: `When you use Music Brackets, we may collect the following information:\n\n- Google account information (name, email, profile picture) when you sign in\n- Bracket game results and preferences\n- Usage data such as pages visited and features used\n- Email address if you subscribe to our email list`,
  },
  {
    title: "II. Use of Information",
    body: `We use the information we collect to:\n\n- Provide and maintain the Music Brackets service\n- Save your bracket history and game progress\n- Improve our services and user experience\n- Send email updates if you have opted in to our email list\n- Analyze usage patterns to improve the platform`,
  },
  {
    title: "III. Sharing and Disclosure of Information",
    body: `We do not sell, trade, or otherwise transfer your personal information to third parties. We may share information only in the following circumstances:\n\n- With your consent\n- To comply with legal obligations\n- To protect our rights and safety`,
  },
  {
    title: "IV. Cookies",
    body: `Music Brackets uses cookies to maintain your login session and remember your preferences. These cookies are essential for the functioning of the service. By using our site, you consent to the use of these cookies.`,
  },
  {
    title: "V. Individual Rights",
    body: `You have the right to:\n\n- Access the personal data we hold about you\n- Request correction of inaccurate data\n- Request deletion of your account and associated data\n- Opt out of email communications at any time`,
  },
  {
    title: "VI. Data Retention",
    body: `We retain your personal information for as long as your account is active or as needed to provide services. You may request deletion of your account data at any time by contacting us.`,
  },
  {
    title: "VII. Security",
    body: `We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.`,
  },
  {
    title: "VIII. Links to Other Websites",
    body: `Music Brackets may contain links to external websites such as YouTube, Genius, and Spotify. We are not responsible for the privacy practices or content of these third-party sites.`,
  },
  {
    title: "IX. Contact Us",
    body: `If you have any questions about this Privacy Policy, please contact us at support@musicrandomizer.com.`,
  },
];

export default function PrivacyPolicyPage() {
  return (
    <Container id="privacy-page" maxWidth="md" sx={{ mt: 4 }}>
      <SeoHead title="Privacy Policy" description="Music Brackets privacy policy. Learn how we collect, use, and protect your data." canonical="/privacy-policy" />
      <Box id="privacy-header" sx={{ textAlign: "center", mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="h6" color="text.secondary">
          <em>Last Updated: February 15, 2026</em>
        </Typography>
      </Box>

      <Paper sx={{ p: 3 }}>
        <Typography variant="body1" paragraph>
          Music Brackets ("we", "us", or "our") is committed to protecting your
          privacy. This Privacy Policy explains how we collect, use, and
          safeguard your information when you use our website.
        </Typography>
        <Typography variant="body1" paragraph>
          By using Music Brackets, you agree to the collection and use of
          information in accordance with this policy. "Personal data" refers to
          any information relating to an identified or identifiable individual.
        </Typography>

        {sections.map((section, index) => (
          <Box key={index} sx={{ mt: index === 0 ? 3 : 2 }}>
            <Typography variant="h5" sx={{ mb: 1 }}>
              {section.title}
            </Typography>
            {section.body.split("\n\n").map((block, blockIdx) => (
              <Typography key={blockIdx} variant="body1" paragraph>
                {block.split("\n").map((line, lineIdx, arr) => (
                  <span key={lineIdx}>
                    {line}
                    {lineIdx < arr.length - 1 && <br />}
                  </span>
                ))}
              </Typography>
            ))}
          </Box>
        ))}
      </Paper>
    </Container>
  );
}
